import React from 'react'
import './TitleSection.css';
interface TitleSectionProps {
    title?: String
}
const TitleSection = (props: TitleSectionProps) => {
    return (
        <div className="title-section">
            <h2>{props.title}</h2>
            <select>
                <option>This Week</option>
                <option>Month</option>
                <option>Year</option>
            </select>
        </div>
    )
}

export default TitleSection;